export default [
  'administrativeInfo',
  'sancareState',
  'sancareCodingAssistance',
  'initialGrouping',
  'currentGrouping',
]
